import { atom } from 'recoil'

export const selectedShrimpTransferState = atom<number | undefined>({
  key: 'selectedShrimpTransferState',
  default: undefined,
})
